import React from 'react';

const VARIANTS = {
  primary: 'bg-axial-primary hover:bg-axial-primary-dark text-white',
  secondary: 'bg-[var(--axial-surface-elevated)] text-[var(--axial-text-primary)] border border-[var(--axial-border)] hover:bg-[var(--axial-surface)]',
  outline: 'bg-transparent border border-[var(--axial-primary)] text-[var(--axial-primary)] hover:bg-[var(--axial-primary)] hover:text-white',
  danger: 'bg-[var(--axial-danger)] text-white hover:bg-red-700',
  ghost: 'bg-transparent text-[var(--axial-text-muted)] hover:bg-[var(--axial-surface-elevated)]',
};

const SIZES = {
  sm: 'h-7 px-3 text-xs',
  md: 'h-10 px-4',
  lg: 'h-12 px-6 text-lg',
};

function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  ...props
}) {
  return (
    <button
      className={`h-9 px-4 rounded-lg font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--axial-primary)] ${SIZES[size]} ${VARIANTS[variant] || VARIANTS.primary} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;
